import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import MobileStoreButton from 'react-mobile-store-button';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: '',
    paragraph: ''
  };
function AddButtonElements(iOSUrl, androidUrl,){
  
}
  return (
    <section
      {...props}
      className={outerClasses}
    >

      <div className="container">
     

        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  </div>
                <h3 className="mt-0 mb-12">
Runner Arrow                  </h3>

                  <div className="App">
                    <div className="d-grid">
                     
                      <div className="grid-column">
                        <MobileStoreButton store="android" url={"https://play.google.com/store/apps/details?id=com.hypergames.RunnerArrow"} linkProps={{title: "Android Store Button"}} />
                      </div>
                    </div>
                  </div>

                <p className="m-0">

                  </p>

              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">

                
                <Image
                  src={require('./../../assets/images/6.png')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>
            </div>
            
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  </div>
                <h3 className="mt-0 mb-12">
                Florist                  </h3>

                  <div className="App">
                    <div className="d-grid">
                     
                      <div className="grid-column">
                        <MobileStoreButton store="android" url={"https://play.google.com/store/apps/details?id=com.hypergames.Florist"} linkProps={{title: "Android Store Button"}} />
                      </div>
                    </div>
                  </div>

                <p className="m-0">

                  </p>

              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">

                
                <Image
                  src={require('./../../assets/images/3.png')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>
            </div>
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  </div>
                <h3 className="mt-0 mb-12">
                Tired Bowman
                  </h3>

                  <div className="App">
                    <div className="d-grid">
                     
                      <div className="grid-column">
                        <MobileStoreButton store="android" url={"https://play.google.com/store/apps/details?id=com.hypergames.TiredBowman"} linkProps={{title: "Android Store Button"}} />
                      </div>
                    </div>
                  </div>

                <p className="m-0">

                  </p>

              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">

                
                <Image
                  src={require('./../../assets/images/9.png')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>
            </div>
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  </div>
                <h3 className="mt-0 mb-12">
Drift Up                  </h3>

                  <div className="App">
                    <div className="d-grid">
                     
                      <div className="grid-column">
                        <MobileStoreButton store="android" url={"https://play.google.com/store/apps/details?id=com.hypergames.DriftUp"} linkProps={{title: "Android Store Button"}} />
                      </div>
                    </div>
                  </div>

                <p className="m-0">

                  </p>

              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">

                
                <Image
                  src={require('./../../assets/images/8.png')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;